window.addEventListener('load', function () {
  var btnFooter2 = document.querySelector(".btn-footer2");
  var footer = document.querySelector(".footer");
  if (btnFooter2 && footer) {
    btnFooter2.addEventListener("click", function (e) {
      e.preventDefault();
      btnFooter2.classList.toggle("active");
      footer.classList.toggle("active");
    });
  }

  var swiper = new Swiper(".mySwiper", {
    effect: "coverflow",
    grabCursor: true,

    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 200,
      depth: 250,
      modifier: 1,
      scale: 1,
      slideShadows: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".banner-dots",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 5
      }
    }
  });
});
